import { KeyboardEvent, useRef, useState } from 'react'

import RoundedButton from 'components/Atoms/Buttons/RoundedButton/RoundedButton'
import Input from 'components/Atoms/Calculator/Input'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

interface FourthStepDriverProps {
  onCalculate: (days: number, distance: number, passenger: number) => void
}

export default function FourthStepDriver({
  onCalculate,
}: FourthStepDriverProps) {
  const { t } = useTranslation('calculator')

  const [daysInput, setDaysInput] = useState('')
  const [distanceInput, setDistanceInput] = useState('')
  const [passengerInput, setPassengerInput] = useState('')

  // refs para mover el foco con Enter
  const daysRef = useRef<HTMLInputElement | null>(null)
  const distanceRef = useRef<HTMLInputElement | null>(null)
  const passengerRef = useRef<HTMLInputElement | null>(null)

  const handleCalculateClick = () => {
    const parsedDays = parseInt(daysInput, 10)
    const days = Number.isNaN(parsedDays) ? 0 : parsedDays

    const parsedDistance = parseFloat(distanceInput.replace(',', '.'))
    const distance = Number.isNaN(parsedDistance) ? 0 : parsedDistance

    const parsedPassenger = parseInt(passengerInput, 10)
    const passenger = Number.isNaN(parsedPassenger) ? 0 : parsedPassenger

    if (days <= 0 || distance <= 0 || passenger <= 0) {
      toast.error(t('calculator.rightColumn.errors.completeAllFields'), {
        theme: 'colored',
      })
      return
    }

    onCalculate(days, distance, passenger)
  }

  const handleKeyDownDays = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      distanceRef.current?.focus()
    }
  }

  const handleKeyDownDistance = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      passengerRef.current?.focus()
    }
  }

  const handleKeyDownPassenger = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleCalculateClick()
    }
  }

  return (
    <div className="h-full flex flex-col justify-end">
      <div className="h-full flex flex-col justify-between max-sm:gap-6 max-sm:items-center">
        <p>{t('calculator.rightColumn.fourthStep.driver.text')}</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label={t('calculator.rightColumn.fourthStep.driver.labelInput1')}
            placeholder={t(
              'calculator.rightColumn.fourthStep.driver.placeholder1',
            )}
            className="w-48 justify-end"
            value={daysInput}
            onChange={setDaysInput}
            onKeyDown={handleKeyDownDays}
            inputRef={daysRef}
          />
          <Input
            label={t('calculator.rightColumn.fourthStep.driver.labelInput2')}
            placeholder={t(
              'calculator.rightColumn.fourthStep.driver.placeholder2',
            )}
            className="w-48 justify-end"
            value={distanceInput}
            onChange={setDistanceInput}
            onKeyDown={handleKeyDownDistance}
            inputRef={distanceRef}
          />
          <Input
            label={t('calculator.rightColumn.fourthStep.driver.labelInput3')}
            placeholder={t(
              'calculator.rightColumn.fourthStep.driver.placeholder3',
            )}
            className="w-48 justify-end"
            value={passengerInput}
            onChange={setPassengerInput}
            onKeyDown={handleKeyDownPassenger}
            inputRef={passengerRef}
          />
        </div>
        <RoundedButton onClick={handleCalculateClick}>
          {t('calculator.rightColumn.fourthStep.driver.cta')}
        </RoundedButton>
      </div>
    </div>
  )
}
